import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { ComparisonOperator } from '@blaze-shared/api-contracts-domain';
import { getActiveBinding } from '@blaze-shared/elements-domain';
import { type BaseSchema, type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';

import { type DataFilterColumnOperator, type DataFilterDefinition } from './data-filter.definition';

export class DataFilterDefinitionMapper implements DefinitionMapper<'dataFilter'> {
  type: 'dataFilter';
  extract(
    element: CanvasElementFrom<'dataFilter'>,
    schemas: Readonly<Record<string, BlazeSchema>>,
  ): PartialDeep<DataFilterDefinition> {
    const binding = getActiveBinding(element.props.data, 'value');
    let tableSchema: BaseSchema | undefined;

    if (binding?.dataSource?.id) {
      tableSchema = schemas[binding.dataSource.id];
    }

    return {
      table: tableSchema?.name,
      search: element.props.content?.searchAndFilters?.searchEnabled,
      columns: element.props.content?.searchAndFilters?.filters
        ?.map((filter) => {
          const column = tableSchema?.columns.find((column) => column.id === filter.filterField);

          if (!column?.name) {
            return undefined;
          }

          return {
            name: column.name,
            operator: filter.operator ? this.resolveColumnOperator(filter.operator) : undefined,
          };
        })
        .filter((column) => !!column),
    };
  }

  private resolveColumnOperator(
    operator: ComparisonOperator,
  ): DataFilterColumnOperator | undefined {
    switch (operator) {
      case ComparisonOperator.Gte:
        return 'GreaterEqual';
      case ComparisonOperator.Gt:
        return 'Greater';
      case ComparisonOperator.Eq:
        return 'Equal';
      case ComparisonOperator.Lt:
        return 'Less';
      case ComparisonOperator.Lte:
        return 'LessEqual';
      default:
        return undefined;
    }
  }
}
